import { z } from "zod";
import { filterGetSchema } from "./filterGetSchema";
import { andFilterGetSchema } from "./andFilterGetSchema";
import { andNotFilterGetSchema } from "./andNotFilterGetSchema";
import { orFilterGetSchema } from "./orFilterGetSchema";

// Note: filterGetSchema needs to be the first value accessed or else you'll get
// a "Cannot access before initialization error" on the recursive filters. That
// is also why exclusionFiltersGetSchema is defined in this same file.

export const filtersGetSchema = z.union([
  z.array(filterGetSchema),
  z.discriminatedUnion("filter_key", [andFilterGetSchema, andNotFilterGetSchema, orFilterGetSchema]),
  z.strictObject({}), // empty object
]);

export const exclusionFiltersGetSchema = z
  .union([
    z.discriminatedUnion("filter_key", [andFilterGetSchema, andNotFilterGetSchema, orFilterGetSchema]),
    z.strictObject({}), // empty object
  ])
  .optional();
